export enum RoutingRulesFormStepName {
    Timing = 'timing',
    ItemsAndConditions = 'itemsAndConditions',
    TargetBill = 'targetBill',
    Summary = 'summary',
}

export enum TimingFieldName {
    Name = 'name',
    Description = 'description',
    TriggerTiming = 'triggerTiming',
    TriggerDay = 'triggerDay',
    TriggerTime = 'triggerTime',
    ConsumptionDate = 'consumptionDate',
}

export enum CompaniesTabs {
    AllProfiles = 'allProfiles',
    LinkedProfiles = 'linkedProfiles',
}

export interface RoutingRuleConditionRate {
    serviceId: string;
    serviceName: string;
    rates: { id: string; name: string }[];
}

export interface RoutingRuleConditions {
    companies: { id: string; name: string }[];
    travelAgencies: { id: string; name: string }[];
    rates: RoutingRuleConditionRate[];
    prepayment: boolean;
}
